document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('code.haskell')).forEach(codeElement => {
        initReadonlyCodeMirror(codeElement.parentElement,codeElement.innerText , 'haskell')
    })
})
document.addEventListener('DOMContentLoaded', () => {
    Array.from(document.querySelectorAll('code.loopwhile')).forEach(codeElement => {
        initReadonlyCodeMirror(codeElement.parentElement,codeElement.innerText , 'loopwhile')
    })
})

        
function initReadonlyCodeMirror(ele, code, mode) {
    let cm = CodeMirror(ele, {
        value: code,
        mode: mode,
        theme: 'default',
        lineWrapping: false,
        readOnly: true,
    });
    /* https://github.com/codemirror/CodeMirror/issues/4762 */
    cm.on('copy', (cm, e) => {
        // ignore copy by codemirror.  and will copy by browser
        e.codemirrorIgnore = true;
    });
    return cm;
}